import React, { useEffect, useState } from "react";
import styled from "styled-components";
import * as Icons from "react-icons/ti";
const StyledContainer = styled.div`
	margin-right: 15px;
	div {
		padding: 20px;
	}
	span {
		display: block;
		font-size: 24px;
		font-weight: 700;
	}
	svg {
		font-size: 48px;
	}
	p {
		display: block;
	}
`;
const DayDetail = (props) => {
	const [icon, setIcon] = useState();

	useEffect(() => {
		let code = props.element.day.condition.code;
		const getData = async () => {
			const response = await fetch("./JSON/weather.json");
			const data = await response.json();
			let iconID = data.find((element) => element.code === code);
			setIcon(Icons[iconID.icon]);
		};
		getData();
	});
	return (
		<StyledContainer>
			<div>
				<span>
					{props.element.date.slice(
						props.element.date.length - 2,
						props.element.date.length
					)}
				</span>
				<span>{icon ? icon : <></>}</span>
				<p>
					Min: {props.element.day.mintemp_c} Max: {props.element.day.maxtemp_c}
				</p>
			</div>
		</StyledContainer>
	);
};

export default DayDetail;
